import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import dynamic from 'next/dynamic';
import * as React from 'react';

const FullTestTableDesktop = dynamic(() =>
  import('./FullTestTable/FullTestTableDesktop').then((mod) => mod.FullTestTableDesktop)
);

const FullTestTableTablet = dynamic(() =>
  import('./FullTestTable/FullTestTableTablet').then((mod) => mod.FullTestTableTablet)
);

export const FullTestList = () => {
  const [, from768] = useFromScreens([0, 768]);

  if (from768) return <FullTestTableDesktop />;
  return <FullTestTableTablet />;
};
